import { IconVideo } from '@vs-shop/ui/icons';
import { ProductGalleryThumbChip } from '@vs-shop/commerce-ui/productGallery';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../../utils/intl';

type Props = { count: number; onClick: () => void };

/** The cell standing for the product's videos, which the rail does not show. */
export function GalleryThumbVideo({ count, onClick }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  const formatedCount = intl.formatNumber(count, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <ProductGalleryThumbChip
      onClick={onClick}
      tabIndex={0}
      aria-label={intl.formatMessage(
        {
          id: 'component.server.page.product.gallery.galleryThumbVideo.videoCount',
          defaultMessage:
            '{count} {count, plural, one {video} =2 {videa} =3 {videa} =4 {videa} other {videí}}',
        },
        { count: formatedCount }
      )}
    >
      <IconVideo />
      <span>
        {intl.formatMessage(
          {
            id: 'component.server.page.product.gallery.galleryThumbVideo.videoCount2',
            defaultMessage:
              '{count} {count, plural, one {video} =2 {videa} =3 {videa} =4 {videa} other {videí}}',
          },
          { count: formatedCount }
        )}
      </span>
    </ProductGalleryThumbChip>
  );
}
